import {
  CHECKOUT_SUBMIT,
  CHECKOUT_SUBMIT_ERROR,
  CHECKOUT_SET_CUSTOMER_INFO,
  CHECKOUT_SET_COMPANY_ADDRESS,
  CHECKOUT_SET_CAMPAIGN_CODE,
  CHECKOUT_SET_DELIVERY_LOADING,
  CHECKOUT_SET_PAYMENT_LOADING,
  CHECKOUT_SET_DELIVERY,
  CHECKOUT_SET_PAYMENT,
  CHECKOUT_SET_ORDER_NOTE,
  CHECKOUT_ACCEPT_TERMS_OF_CONDITION,
  CHECKOUT_SET_PRIVATE_CUSTOMER,
  CHECKOUT_SET_PAYMENT_WIDGET,
  CHECKOUT_SET_SELECTED_COMPANY_ADDRESS,
  CHECKOUT_SET_SIGN_UP,
  CHECKOUT_SET_COUNTRY,
  CHECKOUT_SET_SHIPPING_OPTION,
  CHECKOUT_SET_SELECTED_RESELLER,
  CHECKOUT_SET_WITHOUT_ASSEMBLY,
  CHECKOUT_SET_ACCEPTED_BONUS,
  CHECKOUT_SET_IS_ASSEMBLY_ALLOWED,
  CHECKOUT_SET_BONUS_ERROR,
  CHECKOUT_SET_ENJOY_SIGNUP,
  CHECKOUT_SET_ENJOY_SIGNUP_ERROR,
  CHECKOUT_CLEAR_SUBMIT_ERROR,
  CHECKOUT_SET_USED_DISCOUNT_CODES,
} from '../Actions/Checkout.action';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
  payload: {
    alternativeAddress: {},
    customerDetails: {},
    selectedCompanyAddressId: null,
    isDeliveryLoading: true,
    isPaymentLoading: true,
    selectedDeliveryMethod: {},
    selectedPaymentMethod: {},
    selectedCountry: {},
    campaignCode: '',
    orderNote: {},
    paymentWidget: null,
    isBusinessCustomer: false,
    signUp: false,
    acceptTermsOfCondition: true,

    authenticated: false,
    deliveryMethods: [],
    paymentMethods: [],
    companyAddresses: [],
    responseUrl: '',
    cancelUrl: '',
    redirectUrl: '',
    isAssemblyAllowed: false,
    withoutAssembly: false,
    selectedResellerId: null,
    storeView: {},
    signedUpForEnjoy: false,
  },
  errors: {},
  result: {},
  isSubmitting: false,
};

export const checkout = (state = defaultState, action) => {
  state.payload.privacyBlocks = null;

  const { type, payload } = action;
  switch (type) {
    case CHECKOUT_SUBMIT_ERROR:
      return {
        ...state,
        errors: errorReducer(state.errors, action),
      };
    case CHECKOUT_CLEAR_SUBMIT_ERROR:
      return {
        ...state,
        errors: undefined,
      };
    case CHECKOUT_SUBMIT:
      return {
        ...state,
        ...payload,
      };
    case CHECKOUT_SET_COMPANY_ADDRESS:
    case CHECKOUT_SET_CUSTOMER_INFO:
      return {
        ...state,
        payload: {
          ...state.payload,
          [payload.key]: {
            ...state.payload[payload.key],
            ...payload.data,
          },
        },
      };
    case CHECKOUT_SET_DELIVERY:
    case CHECKOUT_SET_PAYMENT:
    case CHECKOUT_SET_ORDER_NOTE:
    case CHECKOUT_SET_PAYMENT_WIDGET:
    case CHECKOUT_SET_ACCEPTED_BONUS:
    case CHECKOUT_SET_BONUS_ERROR:
    case CHECKOUT_SET_PRIVATE_CUSTOMER:
    case CHECKOUT_SET_SIGN_UP:
    case CHECKOUT_SET_SELECTED_COMPANY_ADDRESS:
    case CHECKOUT_ACCEPT_TERMS_OF_CONDITION:
    case CHECKOUT_SET_CAMPAIGN_CODE:
    case CHECKOUT_SET_COUNTRY:
    case CHECKOUT_SET_SHIPPING_OPTION:
    case CHECKOUT_SET_SELECTED_RESELLER:
    case CHECKOUT_SET_WITHOUT_ASSEMBLY:
    case CHECKOUT_SET_IS_ASSEMBLY_ALLOWED:
    case CHECKOUT_SET_DELIVERY_LOADING:
    case CHECKOUT_SET_PAYMENT_LOADING:
      return {
        ...state,
        payload: {
          ...state.payload,
          ...payload,
        },
      };
    case CHECKOUT_SET_USED_DISCOUNT_CODES:
      return {
        ...state,
        payload: {
          ...state.payload,
          ...payload,
        },
      };
    case CHECKOUT_SET_ENJOY_SIGNUP: {
      return {
        ...state,
        payload: {
          ...state.payload,
          signedUpForEnjoy: payload.signedUpForEnjoy,
        },
      };
    }
    case CHECKOUT_SET_ENJOY_SIGNUP_ERROR: {
      return {
        ...state,
        errors: state.errors.push(payload.action),
      };
    }
    default:
      return state;
  }
};
